import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import '../styles/notification.css';

const Notification = ({ message = '', type = 'success', header = '', onConfirm, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (message && type !== 'warning' && type !== 'info') {
            const timer = setTimeout(() => {
                onClose();
            }, 4000); // Close after 4 seconds

            return () => clearTimeout(timer); // Cleanup the timer on component unmount
        }
    }, [message, type, onClose]);

    if (!message) return null;

    const content = (
        <div className={`notification ${type}`}>
            {header && <div className="notification-header">{header}</div>}
            <div className="notification-body">
                <span className="notification-message">{message}</span>
                {type === 'warning' && (
                    <div className="notification-actions">
                        <button 
                            className="notification-confirm" 
                            disabled={isLoading}
                            onClick={async () => {
                                if (onConfirm) {
                                    setIsLoading(true);
                                    try {
                                        await onConfirm(); // Call the onConfirm callback
                                    } finally {
                                        setIsLoading(false);
                                    }
                                } else {
                                    onClose();
                                }
                            }}
                        >
                            {isLoading ? 'Chargement...' : 'Oui'}
                        </button>
                        <button 
                            className="notification-cancel" 
                            disabled={isLoading}
                            onClick={() => {
                                onClose();
                            }}
                        >
                            Non
                        </button>
                    </div>
                )}
                {type === 'info' && (
                    <div className="notification-actions">
                        <button className="notification-ok" onClick={() => {
                            onClose();
                        }}>OK</button>
                    </div>
                )}
                {type === 'error' && onConfirm && (
                    <div className="notification-actions">
                        <button 
                            className="notification-confirm" 
                            disabled={isLoading}
                            onClick={async () => {
                                if (onConfirm) {
                                    setIsLoading(true);
                                    try {
                                        await onConfirm();
                                    } finally {
                                        setIsLoading(false);
                                    }
                                } else {
                                    onClose();
                                }
                            }}
                        >
                            {isLoading ? 'Chargement...' : 'Réessayer'}
                        </button>
                        <button 
                            className="notification-cancel" 
                            disabled={isLoading}
                            onClick={() => {
                                onClose();
                            }}
                        >
                            Fermer
                        </button>
                    </div>
                )}
                {type !== 'warning' && type !== 'info' && type !== 'error' && (
                    <button className="notification-close" onClick={() => {
                        onClose();
                    }}>&times;</button>
                )}
                {type === 'error' && !onConfirm && (
                    <button className="notification-close" onClick={() => {
                        onClose();
                    }}>&times;</button>
                )}
            </div>
        </div>
    );

    // Render using a portal so it overlays the Navbar and page content
    return ReactDOM.createPortal(content, document.body);
};

Notification.propTypes = {
    message: PropTypes.string,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func, // Add onConfirm prop for confirmation actions
    header: PropTypes.string, // Add header prop for notification header
};

export default Notification;